<template>
  <BCard>
    <b-row class="mx-0">
      <b-button
        variant="primary"
        size="md"
        class="mr-1 rounded-lg p-0"
        @click="$router.go(-1)"
      >
        <feather-icon
          size="2x"
          icon="ChevronLeftIcon"
        />
      </b-button>
      <h3 class="font-semibold text-black text-2xl m-0">
        Detail Jenis Kendala
      </h3>
    </b-row>
    <b-row class="mx-0 my-2 justify-between">
      <b-col>
        <div class="ml-3 text-black text-[16px]">
          {{ isPageDetailSent ? 'Paket Dikirim Terkena Kendala' : 'Jenis Kendala yang Menyebabkan Retur' }}
        </div>
      </b-col>
      <b-col
        md="2"
        class="align-content-center"
      >
        <flat-pickr
          v-model="filterMonth"
          class="custom-select"
          :config="flatpickrMonthly"
        />
      </b-col>
    </b-row>
    <b-overlay
      variant="light"
      :show="isLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-table
        :fields="fieldsTable"
        :items="listData"
        empty-text="Tidak Ada Data Untuk Ditampilkan"
        show-empty
        class="border"
      >
        <template #cell(no)="row">
          {{ row.index + 1 }}
        </template>
        <template #cell(name)="data">
          <div class="d-flex gap-4">
            <div
              class="mr-1 p-[5px] w-[5px] h-[5px] rounded rounded-pill"
              :class="getClass(data.index)"
            />
            <span>
              {{ data.value }}
            </span>
          </div>
        </template>
      </b-table>
    </b-overlay>
  </BCard>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { today, formatYmd } from '@/store/helpers'
import { configFlatPickr, fieldDetailOrder } from './component/config'

export default {
  components: {
    flatPickr,
  },
  data() {
    return {
      isPageDetailSent: true,
      isLoading: false,
      filterMonth: this.$route.params?.date || formatYmd(today),
      flatpickrMonthly: configFlatPickr,
      listData: [],
      fieldsTable: fieldDetailOrder,
    }
  },
  watch: {
    filterMonth(newVal) {
      if (newVal !== null) {
        this.fetchData()
      }
    },
  },
  mounted() {
    this.isPageDetailSent = this.$route.name === 'order-detail-dikirim'
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.isLoading = true
      const url = `/komship/api/v1/delivery-insight/problem-review/${this.isPageDetailSent ? 'sent' : 'return'}/detail`
      const params = {
        date: this.filterMonth,
      }
      await this.$http_new.get(url, { params })
        .then(res => {
          const { data } = res.data
          this.listData = data
          this.isLoading = false
        })
        .catch(res => {
          this.$toast_error({ message: 'Gagal Mendapatkan Data Problem' })
          this.isLoading = false
        })
    },
    getClass(idx) {
      if (idx === 0) return 'bg-[#D6292F]'
      if (idx === 1) return 'bg-[#FF8E00]'
      if (idx === 2) return 'bg-[#5D00FF]'
      return 'bg-[#4F4F4F]'
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-flatpicker.scss';

</style>
